import { Component } from "react";
import { BackgroundInfo } from "../typing";
import styles from '../index.module.less'
import { YBackGroundImage } from "@/utils/style-methods";
export default class HeaderBack extends Component<BackgroundInfo> {
    constructor(props: BackgroundInfo) {
        super(props)
    }

    render() {
        const { headerImg } = this.props

        const cdnImg = YBackGroundImage(headerImg, [{
            mode: 'resize',
            width: 3 * 375
        }])
        return (
            <div className={styles['background-image']} style={{ ...cdnImg }}></div>
        )
    }
}